import React, { useState } from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { MdDelete } from "react-icons/md";
import { useAppDispatch } from "../../../app/hooks";
import AppDialog from "../../../components/dialog/Dialog";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { PAXCOUNTINNUMBER } from "../../../_contstants/common";
import IconButton from "../../../components/common/IconButton";
import { closeDialog } from "../../../components/dialog/dialogSlice";

const TravellerHotelRoomArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const [deleteIndex, setDeleteIndex] = useState(-1);
  const dispatch = useAppDispatch();

  const handleOpenDeleteDialog = (index: number) => {
    setDeleteIndex(index);
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      setDeleteIndex(-1);
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Adults: 2,
        Child: 0,
        // Infant: 0,
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.h5>{"Travellers"}</Typography.h5>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add More Room
        </Button>
      </GridLayoutItem>

      {!fieldArrayRenderProps.value ||
      (fieldArrayRenderProps?.value && fieldArrayRenderProps?.value?.length < 1)
        ? pushElementInarray()
        : null}

      {deleteIndex > -1 && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Room"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Button
                  fillMode={"outline"}
                  themeColor={"error"}
                  onClick={() => setDeleteIndex(-1)}
                  type="button"
                  className="me-2"
                >
                  Cancel
                </Button>
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(deleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      <GridLayoutItem className="bg-dark text-white fw-600">
        <GridLayout
          style={{ marginRight: 30, padding: 5 }}
          gap={{ rows: 10, cols: 10 }}
          cols={[
            { width: "15%" },
            { width: "35%" },
            { width: "35%" },
            { width: "15%" },
          ]}
        >
          <GridLayoutItem>Room</GridLayoutItem>
          <GridLayoutItem>Adult</GridLayoutItem>
          <GridLayoutItem>Child</GridLayoutItem>
          {/* <GridLayoutItem>Infant</GridLayoutItem> */}
          <GridLayoutItem></GridLayoutItem>
        </GridLayout>
      </GridLayoutItem>

      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((room: any, index: number) => (
          <GridLayoutItem key={index} style={{ marginTop: 10 }}>
            <GridLayout
              style={{ marginRight: 30, padding: 5 }}
              gap={{ rows: 10, cols: 10 }}
              cols={[
                { width: "15%" },
                { width: "35%" },
                { width: "35%" },
                { width: "15%" },
              ]}
            >
              <GridLayoutItem style={{ position: "relative" }}>
                <span
                  style={{
                    position: "absolute",
                    top: 5,
                    left: 10,
                    fontWeight: 700,
                  }}
                >
                  {index + 1}
                </span>
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  id={"Adults"}
                  name={`HotelRooms.${index}.Adults`}
                  //   label={"Adult"}
                  placeholder="Adult"
                  //   astrike={true}
                  validator={requiredValidator}
                  component={FormSelectionField}
                  options={PAXCOUNTINNUMBER?.map((count: any) => {
                    return {
                      value: count?.value,
                      label: count?.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  id={"Child"}
                  name={`HotelRooms.${index}.Child`}
                  //   label={"Child"}
                  placeholder="Child"
                  component={FormSelectionField}
                  options={[
                    {
                      value: 0,
                      label: "0",
                    },
                    ...(Array.isArray(PAXCOUNTINNUMBER)
                      ? PAXCOUNTINNUMBER.map((count: any) => ({
                          value: count.value,
                          label: count.label,
                        }))
                      : []),
                  ]}
                />
              </GridLayoutItem>
              {/* <GridLayoutItem>
                <Field
                  id={"Infant"}
                  name={`HotelRooms.${index}.Infant`}
                  //   label={"Infant"}
                  placeholder="Infant"
                  component={FormSelectionField}
                  options={[
                    {
                      value: 0,
                      label: "0",
                    },
                    ...(Array.isArray(PAXCOUNTINNUMBER)
                      ? PAXCOUNTINNUMBER.map((count: any) => ({
                          value: count.value,
                          label: count.label,
                        }))
                      : []),
                  ]}
                />
              </GridLayoutItem> */}
              <GridLayoutItem style={{ textAlign: "center" }}>
                <IconButton
                  onClick={() => handleOpenDeleteDialog(index)}
                  disabled={fieldArrayRenderProps?.value?.length === 1}
                  themeColor={"error"}
                  size={"small"}
                  fillMode={"solid"}
                  type="button"
                  style={{
                    height: 30,
                    width: 30,
                  }}
                  icon={MdDelete}
                  iconClassName="absolute-position"
                  iconStyle={{ fontSize: "24px" }}
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        ))}

      <GridLayoutItem
        style={{
          textAlign: "end",
          marginTop: 20,
        }}
      >
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          type="button"
          onClick={() => {
            const rooms = fieldArrayRenderProps.value || [];

            const totalAdult = rooms.reduce(
              (sum: any, room: any) => sum + (room.Adults || 0),
              0
            );
            const totalChild = rooms.reduce(
              (sum: any, room: any) => sum + (room.Child || 0),
              0
            );
            const totalRoom = rooms.length;
            const totalTravellers = totalAdult + totalChild;

            const totalExtraAdult = rooms.reduce((sum: any, room: any) => {
              const extra = (room.Adults || 0) - 2;
              return sum + (extra > 0 ? extra : 0);
            }, 0);

            fieldArrayRenderProps.formRenderProps.onChange("Travelers", {
              value: totalTravellers,
            });

            fieldArrayRenderProps.formRenderProps.onChange("TotalAdult", {
              value: totalAdult - totalExtraAdult,
            });

            fieldArrayRenderProps.formRenderProps.onChange("TotalChild", {
              value: totalChild,
            });

            fieldArrayRenderProps.formRenderProps.onChange("TotalRoom", {
              value: totalRoom,
            });

            fieldArrayRenderProps.formRenderProps.onChange("ExtraAdult", {
              value: totalExtraAdult,
            });

            dispatch(closeDialog());
          }}
        >
          Save
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default TravellerHotelRoomArray;
